import { areSimpleWorkflowsLoadingSelector, simpleWorkflowsFromDashboard // @ts-expect-error not typed
} from 'EmailData/selectors/details/current/currentSimpleWorkflows';
import { areWorkflowsLoadingSelector, workflowsFromDashboard // @ts-expect-error not typed
} from 'EmailData/selectors/details/current/currentWorkflows';
import { getLastSelectedActionPopoverId, getSelectedEmailRows } from 'EmailData/selectors/manage/table';
import { setLastSelectedActionPopoverId, updateIsPrimaryActionTooltipOpen } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import EmailGroupedActions from 'email-management-lib/refactor/components/shared/EmailGroupedActions';
import { useInsightContext } from 'messaging-publishing-lib/Insights/components/InsightContextProviderBase';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailGroupedActionsContainer = ({
  actionHandlers,
  availableActions,
  className,
  content,
  crmObject,
  hasAutomatedAccess,
  isFramework,
  isPreviewFooter,
  popoverKey,
  responsive
}) => {
  const selectedEmailCount = useSelector(state => getSelectedEmailRows(state).size);
  const areSimpleWorkflowsLoading = useSelector(areSimpleWorkflowsLoadingSelector);
  const areWorkflowsLoading = useSelector(areWorkflowsLoadingSelector);
  const dispatch = useDispatch();
  const onSetLastSelectedActionPopoverId = useCallback(id => dispatch(setLastSelectedActionPopoverId(id)), [dispatch]);
  const onUpdateIsPrimaryActionTooltipOpen = useCallback(payload => dispatch(updateIsPrimaryActionTooltipOpen(payload)), [dispatch]);
  const {
    context: insightContext
  } = useInsightContext();
  const props = {
    actionHandlers,
    availableActions,
    className,
    content,
    crmObject,
    hasAutomatedAccess,
    popoverKey,
    isFramework,
    lastSelectedActionPopoverId: useSelector(getLastSelectedActionPopoverId),
    onSetLastSelectedActionPopoverId,
    areWorkflowsLoading: areWorkflowsLoading || areSimpleWorkflowsLoading,
    isPreviewFooter,
    insightContext,
    responsive,
    workflows: useSelector(workflowsFromDashboard(content.id)),
    simpleWorkflows: useSelector(simpleWorkflowsFromDashboard(content.id)),
    onUpdateIsPrimaryActionTooltipOpen
  };
  return /*#__PURE__*/_jsx(EmailGroupedActions, Object.assign({}, props, {
    selectedEmailCount: selectedEmailCount
  }));
};
export default /*#__PURE__*/memo(EmailGroupedActionsContainer);